/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 6/14/15.
 */
'use strict';
angular
	.module('prism-ui.components')
	.directive('dateTimeEnhanced', function (moment) {
	return {
		restrict: 'E',
		controller: function() {},
		templateUrl: 'components/visual/dateTimeEnhanced/datetime-enhanced-template.html',
		require: ['ngModel', 'dateTimeEnhanced'],
		scope: {
			modifiedLockDate: '=',
			ngModel: '=',
			componentName: '=',
			showTime: '@',
			componentDisabled: '=ngDisabled'
		},
		bindToController: {
			modifiedLockDate: '=',
			ngModel: '=',
			componentName: '=',
			showTime: '=',
			componentDisabled: '=ngDisabled'
		},
		controllerAs: 'dateTimeEnhancedCtrl',

		link: function (scope, element, attrs, ctrls) {
			var ngModelCtrl = ctrls[0];
			var dateTimeEnhancedCtrl = ctrls[1];
			var NONE_DATE = new Date(Date.UTC(9999, 0, 1, 0, 0, 0, 0));
			var DEFAULT_LOCK_DATE = new Date(Date.UTC(2100, 0, 1, 0, 0, 0, 0));
			dateTimeEnhancedCtrl.calBtnId = attrs.id;
			dateTimeEnhancedCtrl.lockedDate = dateTimeEnhancedCtrl.modifiedLockDate || new Date(Date.UTC(2100, 0, 1, 0, 0, 0, 0));

			var isLocked = function (date) {
				return dateTimeEnhancedCtrl.lockedDate.valueOf() === date.valueOf();
			};

			var isDefaultLocked = function (date) {
				return date && date.valueOf() === DEFAULT_LOCK_DATE.valueOf();
			};

			var isNone = function (date) {
				return date && date.valueOf() === NONE_DATE.valueOf();
			};

			/**
			 * Reset displayed (scope) values based on $viewValue
			 */
			ngModelCtrl.$render = function () {
				if (ngModelCtrl.$viewValue) {
					if (isNone(ngModelCtrl.$viewValue.datePart)) {
						dateTimeEnhancedCtrl.datePart = null;
					} else if (isDefaultLocked(ngModelCtrl.$viewValue.datePart)) {
						dateTimeEnhancedCtrl.datePart = new Date(2100, 0, 1, 0, 0, 0, 0);
					} else {
						dateTimeEnhancedCtrl.datePart = ngModelCtrl.$viewValue.datePart;
					}
					dateTimeEnhancedCtrl.isRegularDate = ngModelCtrl.$viewValue.isRegularDate;
					dateTimeEnhancedCtrl.isLockedDate = ngModelCtrl.$viewValue.isLockedDate;
					dateTimeEnhancedCtrl.isNoneDate = ngModelCtrl.$viewValue.isNoneDate;
				}
			};

			/**
			 * Called whenever the model is changed programatically and also on initial loading
			 */
			ngModelCtrl.$formatters.push(function (modelValue) {
				if (modelValue) {
					var date;
					if (!(modelValue instanceof Date)) {
                        if (!dateTimeEnhancedCtrl.showTime) {
						    modelValue = moment.parseZone(modelValue).format('YYYY-MM-DD');
                        }
						date = moment(modelValue).toDate();
					}
					else {
						date = modelValue;
					}
					var locked = isLocked(date);
					var none = isNone(date);

					return {
						datePart: date,
						isRegularDate: !(locked || none),
						isLockedDate: locked,
						isNoneDate: none
					};
				}
			});

			/**
			 * Called when the view value is set manually
			 *
			 * @return The updated view model which is then assigned to $modelValue
			 */
			ngModelCtrl.$parsers.push(function (viewValue) {
				return viewValue.datePart;
			});

			dateTimeEnhancedCtrl.handleLockChange = function () {
				if (!dateTimeEnhancedCtrl.isLockedDate) {
					ngModelCtrl.$setViewValue({
						datePart: dateTimeEnhancedCtrl.lockedDate,
						isLockedDate: true,
						isRegularDate: false,
						isNoneDate: false
					});
				}
				else {
					ngModelCtrl.$setViewValue({
						datePart: dateTimeEnhancedCtrl.datePart,
						isLockedDate: false,
						isRegularDate: true,
						isNoneDate: false
					});
				}

				ngModelCtrl.$render();
			};

			dateTimeEnhancedCtrl.dateChanged = function (componentPart) {
				if (componentPart === 'none') {
					ngModelCtrl.$setViewValue({
						datePart: NONE_DATE,
						isLockedDate: false,
						isRegularDate: false,
						isNoneDate: true
					});
				}
				else {
					ngModelCtrl.$setViewValue({
						datePart: dateTimeEnhancedCtrl.datePart,
						isLockedDate: false,
						isRegularDate: true,
						isNoneDate: false
					});
				}
				ngModelCtrl.$render();
			};
		}
	};
});
